import { render, staticRenderFns } from "./TeacherTop.vue?vue&type=template&id=ec921642&scoped=true&"
import script from "./TeacherTop.vue?vue&type=script&lang=js&"
export * from "./TeacherTop.vue?vue&type=script&lang=js&"
import style0 from "./TeacherTop.vue?vue&type=style&index=0&id=ec921642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec921642",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
